// Models
import Role from '../models/role';
import RoleMakers from '../models/roleMakers';

import {
    FETCH_ROLES_REQUEST,
    FETCH_ROLES_SUCCESS,
    FETCH_ROLES_ERROR,
    HIDE_ROLE_LOADER,
    SHOW_ROLE_LOADER,
    CREATE_ROLE_REQUEST,
    CREATE_ROLE_SUCCESS,
    CREATE_ROLE_ERROR,
    CREATE_ROLE_RESET,
    UPDATE_ROLE_REQUEST,
    UPDATE_ROLE_SUCCESS,
    UPDATE_ROLE_ERROR,
    UPDATE_ROLE_RESET,
    FETCH_ALL_RESOURCE_PERMISSIONS_SUCCESS,
    FETCH_ALL_RESOURCE_PERMISSIONS_ERROR,
    FETCH_ROLE_MAKERS_SUCCESS,
    FETCH_ROLE_MAKERS_ERROR,
} from './roleManagement.constants';

export const initialState = {
    tableData: [],
    pagination: {},
    makerData: [],
    makerPagination: {},
    error: {},
    isLoading: false,
    createRole: {
        message: '',
        isLoading: '',
        isSuccess: false,
        data: {},
    },
    updateRole: {
        message: '',
        isLoading: '',
        isSuccess: false,
        data: {},
    },
    allResourcePermissionDetails: [],
};

export const roleManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        // Fetch Roles
        case FETCH_ROLES_REQUEST:
            return { ...state, error: {} };
        case FETCH_ROLES_SUCCESS: {
            const createUserData = new Role(action.payload);
            return { ...state, ...createUserData, error: {} };
        }
        case FETCH_ROLES_ERROR:
            return {
                ...state,
                allResourcePermissionDetails:
                    state.allResourcePermissionDetails,
                tableData: [],
                pagination: {},
                ...action.payload,
            };
        // Fetch Checkers
        case FETCH_ROLE_MAKERS_SUCCESS:
            const makersList = new RoleMakers(action.payload);
            return {
                ...state,
                ...makersList,
                error: {},
            };

        case FETCH_ROLE_MAKERS_ERROR:
            return {
                ...state,
                ...action.payload,
            };

        // Create Role
        case CREATE_ROLE_REQUEST:
            return {
                ...state,
                createRole: { ...action.payload, isLoading: false },
            };
        case CREATE_ROLE_SUCCESS:
            return {
                ...state,
                createRole: { ...action.payload, isSuccess: true },
            };
        case CREATE_ROLE_ERROR:
            return { ...state, createRole: { ...action.payload } };
        case CREATE_ROLE_RESET:
            return {
                ...state,
                createRole: {
                    message: '',
                    isLoading: '',
                    isSuccess: false,
                    data: {},
                },
            };
        // Update Role
        case UPDATE_ROLE_REQUEST:
            return {
                ...state,
                updateRole: { message: '', isLoading: false },
            };
        case UPDATE_ROLE_SUCCESS:
            return {
                ...state,
                updateRole: { ...action.payload, isSuccess: true },
            };
        case UPDATE_ROLE_ERROR:
            return { ...state, updateRole: { ...action.payload } };
        case UPDATE_ROLE_RESET:
            return {
                ...state,
                updateRole: {
                    message: '',
                    isLoading: '',
                    isSuccess: false,
                    data: {},
                },
            };
        // Get All Resource Permissions
        case FETCH_ALL_RESOURCE_PERMISSIONS_SUCCESS:
            return {
                ...state,
                allResourcePermissionDetails:
                    action.payload.allResourcePermissionDetail,
            };
        case FETCH_ALL_RESOURCE_PERMISSIONS_ERROR:
            const message = action.payload.error;
            return { ...state, createRole: { message } };
        // Fetching Loader
        case SHOW_ROLE_LOADER:
            return { ...state, isLoading: true };
        case HIDE_ROLE_LOADER:
            return { ...state, isLoading: false };
        default:
            return state;
    }
};
